// extracted by css-extract-rspack-plugin
export default {"transferWarningFlash":"IssueTransferDialog-module__transferWarningFlash__BVSJx","noResultsContainer":"IssueTransferDialog-module__noResultsContainer__eXHRS"};